import React, { SyntheticEvent } from 'react';

type UseConfirmDialogArgs = {
  onConfirm?: () => void;
  shouldStopEventPropagation?: boolean;
};

export const useConfirmDialog = ({
  onConfirm,
  shouldStopEventPropagation,
}: UseConfirmDialogArgs = {}) => {
  const [open, setOpen] = React.useState<boolean>(false);

  const onCloseButtonClick = (event: SyntheticEvent) => {
    if (shouldStopEventPropagation) {
      event.stopPropagation();
    }
    setOpen(false);
  };

  const onConfirmButtonClick = (event: SyntheticEvent) => {
    if (shouldStopEventPropagation) {
      event.stopPropagation();
    }
    onConfirm?.();
    setOpen(false);
  };

  return { open, setOpen, onCloseButtonClick, onConfirmButtonClick };
};
